export default __webpack_public_path__ + "static/media/Synapse.3cfd1d07.svg";